export const LIST_BOOKINGS = 'LIST_BOOKINGS';
export const BOOKING_SUCCESS = 'BOOKING_SUCCESS';
export const ASSIGN_BOOKING = 'ASSIGN_BOOKING';
export const RESEND_INVITE = 'RESEND_INVITE';
export const BOOKING_ERROR = 'BOOKING_ERROR';
export const UPDATE_BOOKING = 'UPDATE_BOOKING';
